var materea_t=window.materea_t||(window.materea_t=function(k,v){var d=window.materea_texte;if(!d){try{d=JSON.parse(document.getElementById('materea-i18n').textContent)}catch(e){d={}}window.materea_texte=d}var s=d[k];if(s==null)return k;return v?s.replace(/\{(\w+)\}/g,function(m,n){return n in v?v[n]:m}):s});
(function () {
  'use strict';

  if (window.__materea_workshop_init) return;
  window.__materea_workshop_init = true;

  function bereit(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

   

  function schliesseAlle(root) {
    root.querySelectorAll('.mtl-expander').forEach(function (exp) {
      exp.hidden = true;
    });
    root.querySelectorAll('[data-mtl-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function oeffneEintrag(root, eintrag) {
    var exp = eintrag.querySelector('.mtl-expander');
    if (!exp) return false;
    schliesseAlle(root);
    exp.hidden = false;
    var btn = eintrag.querySelector('[data-mtl-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    return true;
  }

  function initToggles(root) {
    root.querySelectorAll('[data-mtl-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var eintrag = btn.closest('.mtl-eintrag');
        if (!eintrag) return;
        var exp = eintrag.querySelector('.mtl-expander');
        if (!exp) return;
        var warOffen = !exp.hidden;
        schliesseAlle(root);
        if (!warOffen) {
          exp.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

   

  function initWeiche(expander) {
    var radios = expander.querySelectorAll('[data-mtl-sitz]');
    var zweigBuchen = expander.querySelector('[data-mtl-zweig="at"]');
    var zweigAnfrage = expander.querySelector('[data-mtl-zweig="de-eu"]');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        expander.querySelectorAll('.mtl-weiche-option').forEach(function (opt) {
          var input = opt.querySelector('input');
          opt.classList.toggle('gewaehlt', !!(input && input.checked));
        });
        var at = radio.value === 'at';
        if (zweigBuchen) zweigBuchen.hidden = !at;
        if (zweigAnfrage) zweigAnfrage.hidden = at;
      });
    });
  }

   

  function aktuelleAnzahl(form) {
    return parseInt(form.dataset.anzahl || '1', 10);
  }

  function initStepper(form) {
    var minus = form.querySelector('[data-mtb-minus]');
    var plus = form.querySelector('[data-mtb-plus]');
    var anzeige = form.querySelector('[data-mtb-anzahl]');
    var max = parseInt(form.dataset.max, 10) || 1;
    form.dataset.anzahl = '1';

    function anwenden() {
      var n = aktuelleAnzahl(form);
      if (anzeige) anzeige.textContent = String(n);
      if (minus) minus.disabled = n <= 1;
      if (plus) plus.disabled = n >= max;
      form.querySelectorAll('[data-mtb-platz]').forEach(function (feld) {
        feld.hidden = parseInt(feld.dataset.mtbPlatz, 10) > n;
      });
      var hinweis = form.querySelector('[data-mtb-nachreichen]');
      if (hinweis) hinweis.hidden = n < 2;
      var submit = form.querySelector('[data-mtb-submit]');
      var text = submit && submit.querySelector('[data-mtb-submit-text]');
      if (submit && text) {
        text.textContent = n === 1 ? submit.dataset.labelEins : n + ' ' + submit.dataset.labelMehr;
      }
    }

    if (minus) minus.addEventListener('click', function () {
      var n = aktuelleAnzahl(form);
      if (n > 1) { form.dataset.anzahl = String(n - 1); anwenden(); }
    });
    if (plus) plus.addEventListener('click', function () {
      var n = aktuelleAnzahl(form);
      if (n < max) { form.dataset.anzahl = String(n + 1); anwenden(); }
    });
    anwenden();
  }

   

  function zeigeFehler(form, html) {
    var box = form.querySelector('[data-mtb-fehler]');
    if (!box) return;
    box.innerHTML = html;
    box.hidden = false;
  }

  function initFormular(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var box = form.querySelector('[data-mtb-fehler]');
      if (box) { box.hidden = true; box.innerHTML = ''; }

      

      var n = aktuelleAnzahl(form);
      var variantId = parseInt(form.dataset.variantId, 10);
      var items = [];
      for (var i = 1; i <= n; i++) {
        items.push({
          id: variantId,
          quantity: 1,
          properties: {
            'Platz': i + ' von ' + n,
            'Teilnehmer': 'wird nachgereicht',
            'Unternehmerbuchung': 'ja'
          }
        });
      }

      var submit = form.querySelector('[data-mtb-submit]');
      var text = submit && submit.querySelector('[data-mtb-submit-text]');
      var altText = text ? text.textContent : '';
      if (submit) submit.disabled = true;
      if (text) text.textContent = materea_t("js.gemeinsam.einen_moment");

      fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart/add.js", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (res.ok) {
          

          fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart.js", { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (korb) {
              var gemischt = (korb.items || []).some(function (z) {
                return (z.product_type || '') !== 'Workshop';
              });
              window.location.href = gemischt ? ((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart" : ((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"checkout";
            })
            .catch(function () { window.location.href = ((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart"; });
          return;
        }
        if (submit) submit.disabled = false;
        if (text) text.textContent = altText;
        if (res.status === 422) {
          var meldung = materea_t("js.workshop.ausgebucht");
          var warteliste = form.dataset.warteliste;
          if (warteliste) {
            meldung += ' <a href="' + warteliste + materea_t("js.workshop.warteliste_link");
          }
          zeigeFehler(form, meldung);
        } else {
          zeigeFehler(form, materea_t("js.gemeinsam.fehler_nochmal"));
        }
      }).catch(function () {
        if (submit) submit.disabled = false;
        if (text) text.textContent = altText;
        zeigeFehler(form, materea_t("js.gemeinsam.fehler_nochmal"));
      });
    });
  }

   

  function initDeepLinks(root) {
    var params = new URLSearchParams(window.location.search);

    var ort = params.get('ort');
    if (ort) {
      ort = ort.trim().toLowerCase();
      var eintraege = root.querySelectorAll('.mtl-eintrag[data-ort]');
      var treffer = 0;
      eintraege.forEach(function (li) {
        if (li.dataset.ort === ort) treffer++;
      });
      if (treffer > 0) {
        eintraege.forEach(function (li) {
          li.hidden = li.dataset.ort !== ort;
        });
      } else {
         
        var hinweis = root.querySelector('[data-mtl-orthinweis]');
        if (hinweis) {
          var name = hinweis.querySelector('[data-mtl-ortname]');
          if (name) name.textContent = ort.charAt(0).toUpperCase() + ort.slice(1);
          hinweis.hidden = false;
        }
      }
    }

    var variantId = params.get('variant');
    if (variantId) {
      var ziel = root.querySelector('.mtl-eintrag[data-variant="' + variantId + '"]');
      if (ziel) {
        ziel.hidden = false;
        oeffneEintrag(root, ziel);
        var sanft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        ziel.scrollIntoView({ block: 'center', behavior: sanft ? 'smooth' : 'auto' });
      }
    }
  }

   

   

  

  function melde(endpoint, payload) {
    if (!endpoint) return;
    try {
      fetch(endpoint, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (err) {   }
  }

  function sitzVon(form) {
    var wurzel = form.closest('.mtl-expander') || form.closest('[data-materea-kaufzone]');
    var gewaehlt = wurzel ? wurzel.querySelector('[data-mtl-sitz]:checked') : null;
    return gewaehlt ? gewaehlt.value : '';
  }

   

  function initAnfrage(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var box = form.querySelector('[data-mta-fehler]');
      if (box) { box.hidden = true; box.textContent = ''; }
      if (!form.reportValidity()) return;

       
      var hp = form.querySelector('[name="ort_hp"]');
      if (hp && hp.value !== '') return;

      var wert = function (name) {
        var f = form.querySelector('[name="' + name + '"]');
        return f ? f.value.trim() : '';
      };

      

      var uid = wert('uid').replace(/[\s.\-]/g, '').toUpperCase();
      if (uid !== '' && !/^[A-Z]{2}[A-Z0-9]{8,12}$/.test(uid)) {
        if (box) { box.textContent = materea_t("js.workshop.uid_pruefen"); box.hidden = false; }
        return;
      }

      var submit = form.querySelector('[data-mta-submit]');
      var text = form.querySelector('[data-mta-submit-text]');
      var altText = text ? text.textContent : '';
      if (submit) submit.disabled = true;
      if (text) text.textContent = materea_t("js.gemeinsam.einen_moment");

      fetch(form.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          aktion: 'workshop_anfrage',
          termin_id: form.dataset.variantId,
          termin: form.dataset.termin || '',
          sitz: sitzVon(form),
          name: wert('name'),
          firma: wert('firma'),
          email: wert('email'),
          telefon: wert('telefon'),
          uid: uid,
          plaetze: wert('plaetze') || '1'
        })
      }).then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        var ok = form.parentNode.querySelector('[data-mta-ok]');
        form.hidden = true;
        if (ok) ok.hidden = false;
      }).catch(function () {
        if (submit) submit.disabled = false;
        if (text) text.textContent = altText;
        if (box) {
          box.innerHTML = materea_t("js.workshop.fehler_schreib") +
            materea_t("js.workshop.fehler_schreib_2");
          box.hidden = false;
        }
      });
    });
  }

  function initLedger(root) {
    initToggles(root);
    root.querySelectorAll('.mtl-expander').forEach(function (expander) {
      initWeiche(expander);
      var form = expander.querySelector('[data-mtb]');
      if (form) {
        initStepper(form);
        initFormular(form);
      }
      var anfrage = expander.querySelector('[data-mta]');
      if (anfrage) initAnfrage(anfrage);
    });
    initDeepLinks(root);
  }

  

  function initKaufzone(root) {
    initWeiche(root);
    var form = root.querySelector('[data-mtb]');
    if (form) {
      initStepper(form);
      initFormular(form);
    }
    var anfrage = root.querySelector('[data-mta]');
    if (anfrage) initAnfrage(anfrage);
  }

  bereit(function () {
    document.querySelectorAll('[data-materea-ledger]').forEach(initLedger);
    document.querySelectorAll('[data-materea-kaufzone]').forEach(initKaufzone);
  });
})();
